<eaglei-leaflet-layer-header [layer]="this" (activeToggled)="toggleLayer($event)"></eaglei-leaflet-layer-header>

<div class="hide" [class.show]="isActive">
    <!-- We need to use undefined here because 0 is a valid option. -->
    @if (minZoom() !== undefined) { @if( minZoom() > zoomLevel()) {
    <p class="error-message">This layer is not visible at the zoom level, please zoom in</p>
    <button mat-flat-button color="primary" (click)="fitToMinZoom()">Zoom to Layer</button>
    } }
</div>
